import actions from 'src/modules/taskForm/list/taskFormListActions';

const INITIAL_PAGE_SIZE = 10;

const initialData = {
  rows: [] as Array<any>,
  count: 0,
  loading: false,
  filter: {},
  rawFilter: {},
  pagination: {
    current: 1,
    pageSize: INITIAL_PAGE_SIZE,
  },
  sorter: {},
  selectedKeys: [] as Array<any>,
  listFilterKey: 0,
  taskModelFilter: null,
};

const taskFormListReducers = (state = initialData, {type, payload}) => {
  if (type === actions.SET_TASK_MODEL_FILTER) {
    return {
      ...state,
      taskModelFilter: payload,
    };
  }
  if (type === actions.RESETED) {
    return {
      ...initialData,
      taskModelFilter: state.taskModelFilter,
      filter: payload,
      rawFilter: payload,
    };
  }

  if (type === actions.TOGGLE_ONE_SELECTED) {
    let selectedKeys = state.selectedKeys;

    const exists = selectedKeys.includes(payload);

    if (exists) {
      selectedKeys = selectedKeys.filter((key) => key !== payload);
    } else {
      selectedKeys = [payload, ...selectedKeys];
    }

    return {
      ...state,
      selectedKeys,
    };
  }

  if (type === actions.TOGGLE_ALL_SELECTED) {
    const isAllSelected = (state.rows || []).length === (state.selectedKeys || []).length;

    return {
      ...state,
      selectedKeys: isAllSelected ? [] : state.rows.map((row) => row.id),
    };
  }

  if (type === actions.CLEAR_ALL_SELECTED) {
    return {
      ...state,
      selectedKeys: [],
    };
  }

  if (type === actions.PAGINATION_CHANGED) {
    return {
      ...state,
      pagination: payload || {
        current: 1,
        pageSize: INITIAL_PAGE_SIZE,
      },
    };
  }

  if (type === actions.SORTER_CHANGED) {
    return {
      ...state,
      sorter: payload || {},
    };
  }

  if (type === actions.SET_HAS_FILTER) {
    return {
      ...state,
      hasFilter: payload ? payload.hasFilter : {},
      filter: payload ? payload.filter : {},
    };
  }

  if (type === actions.SET_PAYLOAD) {
    return {
      ...state,
      ...payload,
    };
  }

  if (type === actions.PATCH_RECORD) {
    const rows = [...state.rows];
    const values = payload?.values;
    const id = payload?.id;
    if (id && values) {
      const valuesToPatch = ['progreso', 'estado', 'kanbanPosicion', 'secondaryState'];
      const patchData: any = {};
      valuesToPatch.forEach((key) => {
        if (values[key]) {
          patchData[key] = values[key];
        }
      });
      const index = rows.findIndex((row) => row.id === id);
      if (index >= 0) {
        rows[index] = {
          ...rows[index],
          ...patchData,
        };
        //console.log('%c⧭ rows[index]', 'color: #86bf60', rows[index]);
      }
      return {
        ...state,
        rows,
      };
    }
  }

  if (type === actions.FETCH_STARTED) {
    return {
      ...state,
      loading: true,
      selectedKeys: [],
      filter: payload ? payload.filter : {},
      rawFilter: payload ? payload.rawFilter : {},
      pagination:
        payload && payload.keepPagination
          ? state.pagination
          : {
              current: 1,
              pageSize: INITIAL_PAGE_SIZE,
            },
    };
  }

  if (type === actions.FETCH_SUCCESS) {
    return {
      ...state,
      loading: false,
      rows: payload.rows,
      count: payload.count,
    };
  }

  if (type === actions.FETCH_ERROR) {
    return {
      ...state,
      loading: false,
      rows: [],
      count: 0,
    };
  }

  if (type === actions.EXPORT_STARTED) {
    return {
      ...state,
      exportLoading: true,
    };
  }

  if (type === actions.EXPORT_SUCCESS) {
    return {
      ...state,
      exportLoading: false,
    };
  }

  if (type === actions.EXPORT_ERROR) {
    return {
      ...state,
      exportLoading: false,
    };
  }

  return state;
};
export default taskFormListReducers;
